import { handleActions } from 'redux-actions'

import { AUDIO_DEVICE, CAMERA_FACING_MODE, VIDEO_DEVICE } from '@tabeeb/modules/presentation/constants'
import * as deviceActions from '../actions/devices'
import * as jitsiTrackActions from '../actions/jitsiTrack'

export interface DevicesState {
  audioInputId: string
  audioOutputId: string
  videoInputId: string
  facingMode: string
}

const initialState: DevicesState = {
  audioInputId: '',
  audioOutputId: '',
  videoInputId: '',
  facingMode: CAMERA_FACING_MODE.USER,
}

export default handleActions<DevicesState, any>(
  {
    [jitsiTrackActions.addTrackToRoom.toString()](state, action: ReturnType<typeof jitsiTrackActions.addTrackToRoom>) {
      const track = action.payload

      const trackType = track.getType()
      const deviceId = track.getDeviceId()

      switch (trackType) {
        case VIDEO_DEVICE:
          return { ...state, videoInputId: deviceId }
        case AUDIO_DEVICE:
          return { ...state, audioInputId: deviceId }
        default:
          return state
      }
    },
    [deviceActions.setAudioInputDevice.toString()](
      state,
      action: ReturnType<typeof deviceActions.setAudioInputDevice>
    ) {
      return { ...state, audioInputId: action.payload }
    },
    [deviceActions.setAudioOutputDevice.toString()](
      state,
      action: ReturnType<typeof deviceActions.setAudioOutputDevice>
    ) {
      return { ...state, audioOutputId: action.payload }
    },
    [deviceActions.setVideoInputDevice.toString()](
      state,
      action: ReturnType<typeof deviceActions.setVideoInputDevice>
    ) {
      return { ...state, videoInputId: action.payload.deviceId }
    },
    [deviceActions.setMobileCameraFacingMode.toString()](
      state,
      action: ReturnType<typeof deviceActions.setMobileCameraFacingMode>
    ) {
      return { ...state, facingMode: action.payload }
    },
    [deviceActions.resetDevices.toString()]() {
      return initialState
    },
  },
  initialState
)
